import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Users, FileText, Eye, Activity } from 'lucide-react';

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 30px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 24px;
  margin-bottom: 40px;
`;

const StatCard = styled.div`
  background: var(--bg-card);
  padding: 24px;
  border-radius: 16px;
  border: 1px solid var(--glass-border);
  display: flex;
  align-items: center;
  gap: 20px;
  
  .icon {
    width: 60px;
    height: 60px;
    border-radius: 12px;
    background: rgba(99, 102, 241, 0.1);
    color: var(--primary);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .info h3 {
    font-size: 2rem;
    margin-bottom: 4px;
  }
  
  .info p {
    color: var(--text-muted);
    font-size: 0.9rem;
  }
`;

const Dashboard = () => {
    const [stats, setStats] = useState({
        projects: 0,
        services: 0,
        faqs: 0,
        tech: 0
    });

    useEffect(() => {
        const fetchStats = async () => {
            const apiUrl = process.env.REACT_APP_API_URL || '';
            try {
                const [projRes, servRes, faqRes, techRes] = await Promise.all([
                    fetch(`${apiUrl}/api/projects`),
                    fetch(`${apiUrl}/api/services`),
                    fetch(`${apiUrl}/api/faqs`),
                    fetch(`${apiUrl}/api/technologies`)
                ]);

                const projects = await projRes.json();
                const services = await servRes.json();
                const faqs = await faqRes.json();
                const techs = await techRes.json();

                setStats({
                    projects: Array.isArray(projects) ? projects.length : 0,
                    services: Array.isArray(services) ? services.length : 0,
                    faqs: Array.isArray(faqs) ? faqs.length : 0,
                    tech: Array.isArray(techs) ? techs.length : 0
                });
            } catch (err) {
                console.error("Failed to load stats", err);
            }
        };

        fetchStats();
    }, []);

    return (
        <div>
            <Title>Dashboard Overview</Title>

            <Grid>
                <StatCard>
                    <div className="icon"><FileText size={28} /></div>
                    <div className="info">
                        <h3>{stats.projects}</h3>
                        <p>Total Projects</p>
                    </div>
                </StatCard>

                <StatCard>
                    <div className="icon"><Activity size={28} /></div>
                    <div className="info">
                        <h3>{stats.services}</h3>
                        <p>Active Services</p>
                    </div>
                </StatCard>

                <StatCard>
                    <div className="icon"><Users size={28} /></div>
                    <div className="info">
                        <h3>{stats.faqs}</h3>
                        <p>FAQs</p>
                    </div>
                </StatCard>

                <StatCard>
                    <div className="icon"><Eye size={28} /></div>
                    <div className="info">
                        <h3>{stats.tech}</h3>
                        <p>Technologies</p>
                    </div>
                </StatCard>
            </Grid>

            <div style={{ background: 'var(--bg-card)', padding: '30px', borderRadius: '16px', border: '1px solid var(--glass-border)' }}>
                <h2 style={{ marginBottom: '20px' }}>Welcome back, Admin!</h2>
                <p style={{ color: 'var(--text-muted)' }}>
                    You can use the sidebar to navigate and manage the content on the public website.
                    All changes made here will be instantly reflected on the frontend.
                </p>
            </div>
        </div>
    );
};

export default Dashboard;
